import gql from "graphql-tag";

export const SIGNED_URL = gql`query ($extension: String! $size: Int! $urlPart: String) {
    signedUrl (extension: $extension size: $size urlPart: $urlPart)
}`;